import { Axios } from "../axios";

const baseApi = process.env.REACT_APP_NEW_AUTH_SERVER_ID;

export const getMhReferenceId = async (body: any) => {
  const userToken = localStorage.getItem("userToken");
  const payload = {
    name: body?.name,
    email: body?.email,
    phone: body?.phone,
    universityName: body?.institution,
    vendorKey: localStorage.getItem("userKey"),
  };

  return await Axios.post(`${baseApi}/remit/integrations/convera/getMHReferenceId`, payload, {
    headers: {
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
      Authorization: `${userToken}`,
      "X-Route-To": "remittance",
      accept: "*/*",
    },
  });
};

export const getConveraClientSearchByCountry = async ({ countryIso }: { countryIso: string }) => {
  const userToken = localStorage.getItem("userToken");
  if (!userToken) {
    throw new Error("User token is not available");
  }
  return await Axios.post(
    `${baseApi}/remit/integrations/convera/getUniversityList?countryCode=${countryIso}`,
    {},
    {
      headers: {
        "Access-Control-Allow-Origin": "true",
        "Content-Type": "application/json",
        Authorization: userToken,
        "X-Route-To": "remittance",
        accept: "*/*",
      },
    }
  );
};
